export interface DatadogConfig {
  applicationId: string;
  clientToken: string;
  service: string;
  env?: string;
  version?: string;
  trackViewsManually?: boolean;

  sessionSampleRate?: number;
  sessionReplaySampleRate?: number;
  site?: 'datadoghq.eu' | 'datadoghq.com';
  defaultPrivacyLevel?: 'mask-user-input';
}

export enum DatadogContext {
  UserReference = 'id',
  Cpis = 'cpis',
  BrinCode = 'brinCode',
  Role = 'role',
  ArrangementCode = 'arrangementCode',
  ArrangementType = 'arrangementType',
  Feature = 'feature',
}
